// extracted by css-extract-rspack-plugin
export default {"alignRight":"_4d5c6124","alignCenter":"_fbd5eef"};